import { render, staticRenderFns } from "./vFormBase.vue?vue&type=template&id=62a6ed84"
import script from "./vFormBase.vue?vue&type=script&lang=js"
export * from "./vFormBase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports